import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Typography, Layout, Modal } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { authService } from '../../services/api';

import back1 from '../../assets/back_1.jpeg';
import back2 from '../../assets/back_2.jpeg';
import back3 from '../../assets/back_3.jpeg';
import back4 from '../../assets/back_4.jpeg';
import back5 from '../../assets/back_5.jpeg';
import back6 from '../../assets/back_6.jpeg';
import logoImg from '../../assets/logo_color.png';

const { Title, Text } = Typography;
const { Content } = Layout;

const images = [back4, back2, back6, back1, back3, back5];

const Login = () => {
    const [loading, setLoading] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();
    const [currentImage, setCurrentImage] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentImage((prevImage) => (prevImage + 1) % images.length);
        }, 4000);
        return () => clearInterval(interval); 
    }, []);

    const showModal = (title, content) => {
        Modal.error({ title, content });
    };

    const handleLogin = async (values) => {
        const { username: email, password } = values;
        setLoading(true);
        try {
            // Usar novo serviço de autenticação
            const response = await authService.login(email, password);
            
            if (response.access_token && response.user) {
                const { access_token, user } = response;
                login(access_token, user);
                navigate('/mapa-dos-sites');
            } else {
                showModal('Falha no login', 'Resposta inesperada do servidor.');
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                showModal('Credenciais inválidas', 'Verifique seu e-mail e senha.');
            } else {
                console.error('Erro no login:', error);
                const msg = error.response?.data?.message || error.message || 'Sem resposta do servidor. Verifique CORS e FRONTEND_URL no App Runner.';
                showModal('Falha no login', msg);
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <Layout style={{ minHeight: '100vh', flexDirection: 'row' }}>
            <div style={{ flex: 2, position: 'relative', overflow: 'hidden' }}>
                {images.map((image, index) => (
                    <div
                        key={index}
                        style={{
                            backgroundImage: `url(${image})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            opacity: currentImage === index ? 1 : 0,
                            transition: 'opacity 1s ease',
                            zIndex: currentImage === index ? 1 : 0,
                        }}
                    />
                ))}
            </div>

            <Content style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '10px' }}>
                <div style={{ width: '100%', maxWidth: '400px' }}>
                    <img 
                        src={logoImg} 
                        alt="Logo Heliosfera Energias" 
                        style={{ marginBottom: '20px', width: '60%', display: 'block', marginLeft: 'auto', marginRight: 'auto' }}
                    />
                    <Title level={2} style={{ textAlign: 'center' }}>Faça login na conta</Title>
                    <Text type="secondary" style={{ display: 'block', textAlign: 'center', marginBottom: '20px', fontSize:'18px' }}>
                        Digite seu e-mail e senha para continuar
                    </Text>
                    <Form layout="vertical" name="login-form" onFinish={handleLogin}>
                        <Form.Item
                            label="Email"
                            name="username"
                            rules={[{ required: true, message: 'Por favor, digite seu e-mail!' }]}
                        >
                            <Input placeholder="Digite seu Email" style={{height:'45px'}} />
                        </Form.Item>

                        <Form.Item
                            label="Senha"
                            name="password"
                            rules={[{ required: true, message: 'Por favor, digite sua senha!' }]}
                        >
                            <Input.Password placeholder="Digite sua Senha" style={{height:'45px'}} />
                        </Form.Item>

                        <Form.Item>
                            <Button 
                                type="primary" 
                                htmlType="submit" 
                                block 
                                style={{height:'45px', backgroundColor:'#FB8500'}} 
                                loading={loading} 
                            >
                                Entrar
                            </Button>
                        </Form.Item>

                        <Form.Item>
                            <Link to="/forgot-password" style={{ float: 'right' }}>
                                Esqueceu a senha?
                            </Link>
                        </Form.Item>

                        <Form.Item>
                            <Text type="secondary" style={{ display: 'block', textAlign: 'center' }}>
                                Não tem uma conta? <Link to="/register">Cadastrar</Link>
                            </Text>
                        </Form.Item>
                    </Form>
                </div>
            </Content>
        </Layout>
    );
};

export default Login;
